import __request__ from "routing/request";
export function createFromParser(pipeline) {
  return __request__("POST", "/system/pipelines/pipeline", pipeline, {}, {
    "Accept": ["application/json"]
  });
}
export function getAll() {
  return __request__("GET", "/system/pipelines/pipeline", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "title", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/system/pipelines/pipeline/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function parse(pipeline) {
  return __request__("POST", "/system/pipelines/pipeline/parse", pipeline, {}, {
    "Accept": ["application/json"]
  });
}
export function routing(body) {
  return __request__("PUT", "/system/pipelines/pipeline/routing", body, {}, {
    "Accept": ["application/json"]
  });
}
export function getDeprecatedFunctionsForRule(id) {
  return __request__("GET", `/system/pipelines/pipeline/rule/${id}/deprecated_functions`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function get(id) {
  return __request__("GET", `/system/pipelines/pipeline/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(pipeline, id) {
  return __request__("PUT", `/system/pipelines/pipeline/${id}`, pipeline, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(id) {
  return __request__("DELETE", `/system/pipelines/pipeline/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getRulesMetadata(id) {
  return __request__("GET", `/system/pipelines/pipeline/${id}/meta/rules`, null, {}, {
    "Accept": ["application/json"]
  });
}
